import React, { useCallback, useEffect, useMemo, useState } from 'react'

import moment from 'moment-timezone'

import {
  InsightsConversations,
  InsightsConversationsQuery,
} from '@driftt/insights-components'

import { IQueryConfig } from 'api/report/query/types'
import ConversationResultsContext from 'modules/conversationResults/context'

const ConversationResultsSliderContainer = ({ children }) => {
  const [isDrawerModeOpen, setDrawerModeOpen] = useState(false)
  const [query, setQuery] = useState<InsightsConversationsQuery | undefined>()

  const setQueryConfig = useCallback((queryConfig: IQueryConfig) => {
    setQuery({
      startDate: moment(queryConfig.startDate).tz(queryConfig.timezone!),
      endDate: moment(queryConfig.endDate).tz(queryConfig.timezone!),
      pageSize: 20,
      query: {},
    })
  }, [])

  const state = useMemo(
    () => ({
      setQueryConfig,
      setQuery,
    }),
    [setQueryConfig, setQuery]
  )

  useEffect(() => {
    if (query) {
      setDrawerModeOpen(true)
    }
  }, [query])

  const onDrawerClosePress = () => {
    setDrawerModeOpen(false)
  }

  return (
    <>
      <ConversationResultsContext.Provider value={state}>
        {children}
      </ConversationResultsContext.Provider>
      {query && (
        <InsightsConversations
          {...query}
          pageSizes={[10, 20, 30]}
          mode="drawer"
          isDrawerModeOpen={isDrawerModeOpen}
          onDrawerClosePress={onDrawerClosePress}
        />
      )}
    </>
  )
}

export default ConversationResultsSliderContainer
